import React, { useEffect, useRef } from 'react';
import '../styles/Timeline.css';

const Timeline = ({ trackingHistory }) => {
  const timelineRef = useRef(null);

  useEffect(() => {
    // Auto-scroll to bottom to show latest update
    if (timelineRef.current) {
      timelineRef.current.scrollTop = timelineRef.current.scrollHeight;
    }
  }, [trackingHistory]);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return {
      date: date.toLocaleDateString('en-US', { 
        weekday: 'short', 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      }),
      time: date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })
    };
  };

  if (!trackingHistory || trackingHistory.length === 0) {
    return (
      <div className="timeline-empty">
        <p>No tracking information available</p>
      </div>
    );
  }

  return (
    <div className="timeline-container" ref={timelineRef}>
      <div className="timeline">
        {trackingHistory.map((item, index) => {
          const isLatest = index === trackingHistory.length - 1;
          const formatted = formatTimestamp(item.timestamp);
          
          return (
            <div 
              key={`${item.trackingNumber}-${index}`} 
              className={`timeline-item ${isLatest ? 'latest' : ''}`}
            >
              <div className="timeline-node">
                <div className="node-circle"></div>
                <div className="node-line"></div>
              </div>
              
              <div className="timeline-content">
                <div className="status-text">{item.status}</div>
                <div className="timestamp">
                  <span className="date">{formatted.date}</span>
                  <span className="time">{formatted.time}</span>
                </div>
                {isLatest && (
                  <div className="latest-indicator">
                    <span>Latest Update</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Timeline;